let isNotifying = false;
let lastErrorKey: string | null = null;

const ERROR_NOTIFY_COOLDOWN_MS = 3000;

export function notifyErrorOnce(
    message: string,
    notify: (msg: string) => void
) {
    const errorKey = message;

    if (isNotifying && lastErrorKey === errorKey) {
        return;
    }

    isNotifying = true;
    lastErrorKey = errorKey;

    notify(message);

    setTimeout(() => {
        isNotifying = false;
        lastErrorKey = null;
    }, ERROR_NOTIFY_COOLDOWN_MS);
}
